import { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Bloque de la ficha que se abre solo si el usuario quiere ver el detalle. */
export function Plegable({ titulo, icono: I, color, testid, children }) {
  const [abierto, setAbierto] = useState(false);
  return <>
    <button type="button" onClick={() => setAbierto(!abierto)} className={`w-full flex items-center gap-1.5 text-sm font-semibold ${color}`} aria-expanded={abierto} data-testid={`${testid}-toggle`}>
      {I && <I className="w-4 h-4" />}<span className="text-left">{titulo}</span>
      <span className="ml-auto text-[11px] font-medium opacity-70">{abierto ? "ocultar" : "ver detalle"}</span>
      <ChevronDown className={`w-4 h-4 transition-transform ${abierto ? "rotate-180" : ""}`} />
    </button>
    {abierto && children}
  </>;
}
